<template>
  <div>
    <span style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px" class="has-text-grey">
      {{ setting.label || name }}
      <Tooltip :label="setting.label || name" :content="setting.detail" />
    </span>
    <el-date-picker
      v-model="value[name]"
      type="daterange"
      range-separator="To"
      format="dd-MM-yyyy"
      start-placeholder="Start date"
      end-placeholder="End date"
      style="margin-bottom: 20px"
    >
    </el-date-picker>
  </div>
</template>

<script>
/**
 * Daterange SmartField - Renders a date range picker for date range configuration values.
 *
 * @component
 * @description Displays a date range picker with start and end date selection.
 * Format is DD-MM-YYYY for both dates. Stores an array of two dates [startDate, endDate].
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the date range picker (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Array<Date|string>} [setting.default] - Default date range [start, end] if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Daterange
 *   :value="config"
 *   :setting="{ label: 'Campaign Period', detail: 'Select start and end dates' }"
 *   name="campaignPeriod"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
